import { StreamCardFragmentFragment } from '@/__generated__/graphql';
import { NavLink } from '@/routes-utils/navigation.tsx';
import { paths } from '@/routes-utils/paths.ts';
import { getMonthlyPrice } from '@/utils/paid-data.ts';
import {
  HomeStreamCardFeaturedBadge,
  HomeStreamCardFollowersBlock,
  HomeStreamAuthor,
  HomeStreamCardPriceTag,
  HomeCardNameAndDescription,
  HomeStreamCardCategoryBadge,
} from './home-stream-card.tsx';
import {
  homeStreamCardMini,
  homeStreamCardMiniHeader,
  homeStreamCardMiniAdditionalInfo,
  homeStreamCardAdditionalInfoRight,
  homeStreamCardMiniLink,
} from './home-streams-section.css.ts';

export const HomeStreamCardMini = ({
  stream,
}: {
  stream: StreamCardFragmentFragment;
}) => {
  return (
    <div className={homeStreamCardMini}>
      <NavLink
        className={homeStreamCardMiniLink}
        to={paths.makeStream(stream.id)}
      >
        <header className={homeStreamCardMiniHeader}>
          <HomeStreamCardCategoryBadge category={stream.streamCategory} />
          <HomeStreamCardPriceTag price={getMonthlyPrice(stream.paidData)} />
        </header>
        <main>
          <HomeCardNameAndDescription
            rowLimit={{
              name: 2,
            }}
            name={stream.name}
            size="small"
          />
        </main>
        <div className={homeStreamCardMiniAdditionalInfo}>
          <HomeStreamAuthor startWithBy={false} author={stream.author} />
          <div className={homeStreamCardAdditionalInfoRight}>
            <HomeStreamCardFollowersBlock
              followersCount={stream.followersCount}
            />
            {stream.isFeatured && <HomeStreamCardFeaturedBadge short />}
          </div>
        </div>
      </NavLink>
    </div>
  );
};
